import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { createSelector } from 'reselect'
import UserSettings from '../../pages/UserSettings'
import { getUser } from '../../selectors/initialization'
import { getSettings } from '../../selectors/settings'
import {
  setupMfa,
  renewRecoveryCodes,
  revokeMfaConfirmationDismissed,
  selectMFAToRevoke
} from '../../actions/mfaSettings'
import { SETTINGS, CHANGE_PASSWORD, DISABLE_MFA } from '../../constants/routes'

export const mapStateToProps = createSelector(
  [getUser, getSettings],
  (user, settings) => ({
    user,
    ...settings
  })
)

export const mapDispatchToProps = dispatch => ({
  mfaActions: {
    onSetupMFA: () => dispatch(setupMfa({ isFromSettings: true })),
    onSetupMFAMechanism: target =>
      dispatch(push(target, { isFromSettings: true })),
    onRecoveryCodesRenew: () => dispatch(renewRecoveryCodes()),
    onRecoveryCodesRenewConfirm: () => dispatch(push(SETTINGS)),
    onDismissMFAMechanismConfirm: () =>
      dispatch(revokeMfaConfirmationDismissed()),
    onSelectMFAToRevoke: mfaToRevoke =>
      dispatch(selectMFAToRevoke({ mfaToRevoke })),
    goToDisableMFAPage: () => dispatch(push(DISABLE_MFA))
  },
  passwordActions: {
    goToChangePasswordPage: () => dispatch(push(CHANGE_PASSWORD))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings)
